module.exports = __webpack_public_path__ + "img/20180815_150119_055.b1122aae.jpg";